import repository from '@/utils/repository';

const resource = '/move/MNG_WorkReport002';

export default {
    getData: (data) => {
        return repository.post(`${resource}/getData`, {
            ...data
        });
    },
    getOrderDetail: (data) => {
        return repository.post(`${resource}/getOrderDetail`, {
            ...data
        });
    },
    searchPastSalesReport: (data) => {
        return repository.post(`${resource}/searchPastSalesReport`, {
            ...data
        });
    },
    saveData: (data) => {
        return repository.post(`${resource}/storeData`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    getComments: (data) => {
        return repository.post(`${resource}/getComments`, {
            ...data
        });
    },
    storeComment: (data) => {
        return repository.post(`${resource}/storeComment`, {
            ...data
        });
    },
    deleteComment: (data) => {
        return repository.post(`${resource}/deleteComment`, {
            ...data
        });
    },
    getMentions: (data) => {
        return repository.post(`${resource}/getMentions`, {
            ...data
        });
    }
};
